import React from 'react';
import AboutTitle from '../AboutTitle/AboutTitle';
import MethodList from '../MethodList/MethodList';
import classes from "./Method.module.css";
import coin from "../../asstets/imgs/coin.webp";
import coin2 from "../../asstets/imgs/coin2.webp";

export default function Method() {
    const firstList = {
        firstDesc: "Exchange SOL <br /> and ETH",
        secondDesc: "Birds Staking",
        thridDesc: `For participation in our communities’ private competitions`
    }

    const secondList = {
        firstDesc: `NFT joint purchases at an early stage`,
        secondDesc: `Buying the SOL BIRDS merch`,
        thridDesc: `Buying WL, which we will get for our DAO from other projects`
    }

    return (
        <section className={classes.Method} id="birdscoin">
            <div className="container">
                <AboutTitle title="BIRDS" sub="coin" black={true} />
                <div className="row">
                    <div className="col-md-12 col-sm-6 col-xs-12">
                        <div className={classes.method_first_title}>
                            <h3 className={classes.title}>
                                BIRDS COIN <br />
                                Mining methods
                            </h3>
                            <div className={classes.method_firts_title_frame}>
                                <svg width="648" height="386" viewBox="0 0 648 386" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.12012 74.2301C62.3701 46.6801 127.12 32.9001 193.12 22.1401C261.81 10.9001 334.62 4.64014 406.79 2.68014C455.01 1.36014 503.99 -0.129881 544.65 23.0001C579.83 43.0001 600.06 84.0701 600.99 124.55C601.92 165.03 585.56 204.49 561.59 237.12C524.1 288.12 468.59 323.99 409.36 346.23C350.13 368.47 286.8 377.98 223.77 383.9" stroke="#161616" strokeWidth="3" strokeMiterlimit="10" strokeDasharray="30 30" />
                                    <path d="M539.43 340.19C591.86 307.07 630.78 253.19 645.74 193" stroke="#FFA800" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M535.43 329.59C536.351 332.973 536.428 336.531 535.656 339.951C534.884 343.371 533.285 346.55 531 349.21C538.703 345.403 547.276 343.699 555.85 344.27" stroke="#FFA800" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className={classes.method_firts_title_coin}>
                                <img src={coin} alt="coin" />
                            </div>
                        </div>
                        <MethodList first={firstList?.firstDesc} second={firstList?.secondDesc} three={firstList?.thridDesc} />
                    </div>

                    <div className="col-md-12 col-sm-6 col-xs-12">
                        <div className={classes.method_second_title}>
                            <h3 className={classes.title}>
                                What you can spend <br />
                                BIRDS COIN on
                            </h3>
                            <div className={classes.method_second_title_frame}>
                                <svg width="742" height="288" viewBox="0 0 742 288" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M155.23 1.78027C110.9 5.00027 76.18 48.3903 74.12 92.7803C72.06 137.17 97.3 179.63 131.91 207.51C166.52 235.39 209.55 250.64 252.59 261.71C413.26 303.07 587 291.79 741.01 230.11" stroke="#161616" strokeWidth="3" strokeMiterlimit="10" strokeDasharray="30 30" />
                                    <path d="M53.2751 42.2441C22.3153 61.737 16.1557 104.304 24.8304 139.858C33.5445 175.475 55.3892 206.488 85.992 226.688" stroke="#FFA800" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M80.9124 232.294C85.6334 231.872 90.3906 232.424 94.8894 233.916C92.2293 229.855 91.2164 224.933 92.0567 220.152" stroke="#FFA800" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className={classes.method_second_title_coin}>
                                <img src={coin2} alt="coin" />
                            </div>
                            <div className={classes.method_second_title_shape}>
                                <svg width="112" height="94" viewBox="0 0 112 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M103.331 60.22C75.0744 37.7097 37.9807 26.6055 2.0001 29.8921" stroke="#FFA800" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M98.2638 64.4494C99.9493 63.2954 101.892 62.572 103.922 62.3424C105.951 62.1128 108.006 62.3841 109.907 63.1325C106.338 59.6224 103.76 55.2316 102.434 50.4047" stroke="#FFA800" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <MethodList secondList={true} first={secondList?.firstDesc} second={secondList?.secondDesc} three={secondList?.thridDesc} />
                    </div>

                </div>
                <div className={classes.leran_more_btn}>
                    <div className={classes.leran_more_frame}>
                        <svg width="62" height="29" viewBox="0 0 62 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 14.2739C5.91585 4.18224 18.7406 -0.237767 29.7453 1.93899C40.75 4.11575 49.9771 11.6679 57.2329 20.26" stroke="#FFC700" stroke-width="1.81397" stroke-miterlimit="10" />
                            <path d="M45.5027 19.5405C50.8722 20.2025 55.8689 22.6317 59.706 26.4456L61 14.6972" stroke="#FFC700" stroke-width="1.81397" stroke-miterlimit="10" />
                        </svg>
                    </div>
                    <a href="https://medium.com/@heylunabirds/tokenomics-birds-coin-68d3322fea3d" target="_blank" >Learn more</a>
                </div>
            </div>
        </section>
    )
}
